import Service from './Service';

export default class Params extends Service {

  findParam(paramName) {
    return this.axiosInstance.get(`/params?paramName=${paramName}`);
  }

}